<template>
  <div class="nav">
    <div class="logo" :style="{backgroundImage: 'url('+logoUrl+')'}"></div>
    <div class="right clearfix">
      <span class="btn add" @click="leftClick">
        <i class="icon" :style="{backgroundImage: 'url('+eqIconUrl+')'}"></i>
        <span class="text">设备列表</span>
      </span>
      <span class="line"> | </span>
      <span class="btn setting" @click="rightClick">
        <i class="icon" :style="{backgroundImage: 'url('+setIconUrl+')'}"></i>
        <span class="text">设置</span>
      </span>
    </div>
  </div>
</template>

<script>
import Common from '../../../assets/js/common.js'
export default {
  name: 'MainNav',
  data () {
    return {
      logoUrl: Common.staticHref() + 'img/logoIcon.png',
      setIconUrl: Common.staticHref() + 'img/settingIcon.png',
      eqIconUrl: Common.staticHref() + 'img/sbIcon.png'
    }
  },
  methods: {
    leftClick () {
      this.$emit('addEquipment', '')
    },
    rightClick () {
      this.$emit('goSetting', '')
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.nav
  padding 0 20px
  height 48px
  background #ffffff
  border-bottom 1px solid #EDEDED
  rowSpaceBetween()
  .logo
    width 69px
    height 48px
    backgroundImg()
  .right
    font-size 12px
    line-height 48px
    height 48px
    .btn
      display inline-block
      padding-left 24px
      position relative
      .icon
        display inline-block
        width 24px
        height 24px
        left 0
        top 10px
        position absolute
        backgroundImg()
    .add
      padding-right 4px
</style>


// WEBPACK FOOTER //
// src/pages/Main/components/nav.vue